// import { routeTypes } from "./useSystemRoutes"
import { documentTypes } from "../../hooks/api/useDocuments"
import { repositoryTypes } from "../../hooks/api/useRepositories"
import { regionTypes } from "../../hooks/api/useRegions"
import { itemTypes } from "../../hooks/api/useItems"
import { businessTypes } from "../../hooks/api/useBusiness"
import { logisticTypes } from "../../hooks/api/useLogistics"
import { reportTypes } from "../../hooks/api/useReports"
import { customFieldTypes } from "../../hooks/api/useCustomFields"
import { targetTypes as walletTypes } from "../../hooks/api/useWallets"
import { targetTypes as transactionTypes } from "../../hooks/api/useTransactions"

// import { propTypes as injectionPropTypes } from "../../hooks/api/useInjectionProps"
import { userTypes as _userTypes } from "../../hooks/api/useUsers"
import { branchUserTypes } from "../../hooks/api/useBranchUsers"
import { branchTypes } from "../../hooks/api/useBranches"
import { groupTypes } from "../../hooks/api/useGroups"
// import { inventoriesTypes } from "../../hooks/api/useInventories"
import { schedulerTypes } from "../../hooks/api/useSchedulers"
import { rateTypes } from "../../hooks/api/useRates"
import { targetTypes as userApiKeyTypes } from "../../hooks/api/useUserApiKeys";
// import { auditTrailTypes } from "../../hooks/api/useAuditTrails"
// import { auditTrailTypes as auditTagTypes } from "../../hooks/api/useAuditTrailTags"
// import { useTranslations } from "../../hooks/useTranslations";

export const userTypes = _userTypes

export const scopeIds = {
    product: { id: "product", value: "product", label: "Products", description: "" },
    document: { id: "document", value: "document", label: "Documents", description: "" },
    repository: { id: "repository", value: "repository", label: "Repositories", description: "" },
    logistic: { id: "logistic", value: "logistic", label: "Logistics", description: "" },
    operation: { id: "operation", value: "operation", label: "Operations", description: "" },
    user: { id: "user", value: "user", label: "Users", description: "" },
    userRole: { id: "userRole", value: "user_role", label: "Roles and Permissions", description: "" },
    userBranches: { id: "userBranches", value: "user_branch", label: "User Branches", description: "" },
    branchUsers: { id: "branchUsers", value: "branch_user", label: "Branch Users", description: "" },
    group: { id: "group", value: "group", label: "User Groups", description: "" },
    region: { id: "region", value: "region", label: "Regions", description: "" },
    business: { id: "business", value: "business", label: "Business", description: "" },
    customField: { id: "customField", value: "custom_field", label: "Custom Fields", description: "" },
    injectionProp: { id: "injectionProp", value: "injection_prop", label: "Injection Props", description: "" },
    injectionField: { id: "injectionField", value: "injection_field", label: "Injection Fields", description: "" },
    report: { id: "report", value: "report", label: "Reports", description: "" },
    scheduler: { id: "scheduler", value: "scheduler", label: "Schedulers", description: "" },
    rate: { id: "rate", value: "rate", label: "Rates", description: "" },
    audit: { id: "audit", value: "audit_trail", label: "Audit Trails", description: "" },
    wallet: { id: "wallet", value: "wallet", label: "Wallets", description: "" },
    transaction: { id: "transaction", value: "transaction", label: "Transactions", description: "" },
    userApiKey: { id: "userApiKey", value: "userApiKey", label: "User API Keys", description: "" }
}

export const scopeTypes = {

    [scopeIds.product.id]: {
        product: { id: itemTypes.product, label: "Manage Items", description: "Product Catalogue" },
        item: { id: itemTypes.item, label: "Manage Item Uoms", description: "Sku Items Catalogue" },
        brand: { id: itemTypes.brand, label: "Manage Brands", description: "Product Brands" },
        category: { id: itemTypes.category, label: "Manage Categories", description: "Organize Product Category" },
        uom: { id: itemTypes.uom, label: "Manage Uoms", description: "Unit Measures" },
    },
    [scopeIds.document.id]: {
        salesOrder: { id: documentTypes.salesOrder, label: "Sales Orders", description: "All Functions" },
        proformaSales: { id: documentTypes.proformaSales, label: "Proforma Sales", description: "All Functions" },
        cashSales: { id: documentTypes.cashSales, label: "Cash Sales", description: "All Functions" },
        retailCashSales: { id: documentTypes.retailCashSales, label: "Retail Cash Sales", description: "All Functions" },
        deliveryOrder: { id: documentTypes.deliveryOrder, label: "Delivery Orders", description: "All Functions" },
        replacementDelivery: { id: documentTypes.replacementDelivery, label: "Replacement Delivery", description: "All Functions" },
        salesDebitNote: { id: documentTypes.salesDebitNote, label: "Sales Debit Notes", description: "All Functions" },
        salesCreditNote: { id: documentTypes.salesCreditNote, label: "Sales Credit Notes", description: "All Functions" },
        salesInvoice: { id: documentTypes.salesInvoice, label: "Sales Invoice", description: "All Functions" },
        purchaseOrder: { id: documentTypes.purchaseOrder, label: "Purchase Orders", description: "All Functions" },
        purchaseReturn: { id: documentTypes.purchaseReturn, label: "Purchase Returns", description: "All Functions" },
        purchaseInvoice: { id: documentTypes.purchaseInvoice, label: "Purchase Invoices", description: "All Functions" },
        itemReceive: { id: documentTypes.itemReceive, label: "Item Receives", description: "All Functions" },
        itemTransfer: { id: documentTypes.itemTransfer, label: "Item Transfers", description: "All Functions" },
        itemRelocate: { id: documentTypes.itemRelocate, label: "Item Relocates", description: "All Functions" },
        itemTransform: { id: documentTypes.itemTransform, label: "Item Transforms", description: "All Functions" },
        itemIssue: { id: documentTypes.itemIssue, label: "Item Issues", description: "All Functions" },
        itemAdjustment: { id: documentTypes.itemAdjustment, label: "Item Adjustments", description: "All Functions" },
        stockTake: { id: documentTypes.stockTake, label: "Stock Takes", description: "All Functions" },
        transferReturn: { id: documentTypes.transferReturn, label: "Transfer Returns", description: "All Functions" },
        transferRequisition: { id: documentTypes.transferRequisition, label: "Transfer Requisitions", description: "All Functions" },
        tripOrder: { id: documentTypes.tripOrder, label: "Delivery Trips", description: "All Functions" },
        pickOrder: { id: documentTypes.pickOrder, label: "Pick Orders Trips", description: "All Functions" },
        retailPrescription: { id: documentTypes.retailPrescription, label: "Retail Prescriptions", description: "All Functions" },
    },
    [scopeIds.repository.id]: {
        container: { id: repositoryTypes.container, label: "Containers", description: "Shipment Containers" },
        package: { id: repositoryTypes.package, label: "Packages", description: "Item Packages" }
    },
    [scopeIds.logistic.id]: {
        transporter: { id: logisticTypes.transporter, label: "Transporters", description: "Fulfillment Parties" },
    },
    [scopeIds.operation.id]: {
        examineInventory: { id: "examine_inventory", label: "Examine Inventory", description: "View Item Inventory" },
        itemRelocateThreshold: { id: "item_relocate_threshold", label: "Relocate Threshold", description: "Relocate Threshold Control" },
        itemReorderThreshold: { id: "item_reorder_threshold", label: "Reorder Threshold", description: "Reorder Threshold Control" },
    },
    [scopeIds.user.id]: {
        administrator: { id: userTypes.admin, label: "Manage Administrators", description: "All Functions" },
        customer: { id: userTypes.customer, label: "Manage Customers", description: "All Functions" },
        driver: { id: userTypes.driver, label: "Manage Drivers", description: "All Functions" },
        member: { id: userTypes.member, label: "Manage Members", description: "All Functions" },
        retail: { id: userTypes.retail, label: "Manage Retailers", description: "All Functions" },
        supplier: { id: userTypes.supplier, label: "Manage Suppliers", description: "All Functions" },
        worker: { id: userTypes.worker, label: "Manage Workers", description: "All Functions" },
    },
    [scopeIds.userRole.id]: {
        description: "",
        role: { id: `role`, label: "Roles", description: "User Roles" },
        permission: { id: `permission`, label: "Permissions", description: "Assign Permissions" }
    },
    [scopeIds.userBranches.id]: {
        customer: { id: branchTypes.customer, label: "For Customers", description: "Customer Branches" },
        retail: { id: branchTypes.retail, label: "For Retailers", description: "Retail Outlets" }
    },
    [scopeIds.branchUsers.id]: {
        customer: { id: branchUserTypes.customer, label: "For Customers", description: "Customer Branch Users" },
        retail: { id: branchUserTypes.retailer, label: "For Retailers", description: "Retail Outlet Users" },
    },
    [scopeIds.group.id]: {
        administrator: { id: groupTypes.administrator, label: "For Administrators", description: "All Functions" },
        customer: { id: groupTypes.customer, label: "For Customers", description: "All Functions" },
        supplier: { id: groupTypes.supplier, label: "For Suppliers", description: "All Functions" },
    },
    [scopeIds.region.id]: {
        country: { id: regionTypes.country, label: "Country", description: "All Functions" },
        area: { id: regionTypes.area, label: "Area", description: "All Functions" }
    },
    [scopeIds.business.id]: {
        business: { id: businessTypes.business, label: "Manage Business", description: "Multiple business entity" }
    },
    [scopeIds.customField.id]: {
        customField: { id: customFieldTypes.account, label: "Manage Custom Fields", description: "Custom Fields For Certain Resources" }
    },
    [scopeIds.injectionProp.id]: {
        injectionProp: { id: `default`, label: "Manage Injection Props", description: "Injection Props For Certain Resources" }
    },
    [scopeIds.injectionField.id]: {
        injectionField: { id: `default`, label: "Manage Injection Fields", description: "Injection Fields For Certain Resources" }
    },
    [scopeIds.report.id]: {
        productItem: { id: reportTypes.product.productItem.key, label: "Product Items", description: "All Functions" },
        sales: { id: reportTypes.sales.salesOrder.key, label: "Sales Orders", description: "All Functions" },
        salesItem: { id: reportTypes.sales.salesOrderItem.key, label: "Sales Order Items", description: "All Functions" },
        delivery: { id: reportTypes.sales.deliveryOrder.key, label: "Delivery Orders", description: "All Functions" },
        deliveryItem: { id: reportTypes.sales.deliveryOrderItem.key, label: "Delivery Order Items", description: "All Functions" },
        itemReceive: { id: reportTypes.warehouse.itemReceive.key, label: "Item Receives", description: "All Functions" },
        itemReceiveItem: { id: reportTypes.warehouse.itemReceiveItem.key, label: "Item Receive Items", description: "All Functions" },
        itemTransfer: { id: reportTypes.warehouse.itemTransfer.key, label: "Item Transfers", description: "All Functions" },
        itemTransferItem: { id: reportTypes.warehouse.itemTransferItem.key, label: "Item Transfer Items", description: "All Functions" },
        // retailCashSales: { id: reportTypes.sales.retailCashSales.key, label: "Retail Cash Sales", description: "All Functions" },
        // retailPrescription: { id: reportTypes.other.retailPrescription.key, label: "Retail Prescriptions", description: "All Functions" },
    },
    [scopeIds.scheduler.id]: {
        task: { id: schedulerTypes.schedulerTask, label: "Manage Task Schedule", description: "" },
        log: { id: schedulerTypes.schedulerLog, label: "Manage Log Schedule", description: "" },
        request: { id: schedulerTypes.schedulerRequest, label: "Manage Request Schedule", description: "" },
        console: { id: `console`, label: "Scheduler Console", description: "" }
    },
    [scopeIds.rate.id]: {
        shippingRate: { id: rateTypes.shippingRate, label: "Manage Shipping Rate", description: "" },
        shippingRule: { id: rateTypes.shippingRule, label: "Manage Shipping Rule", description: "" },
        taxRate: { id: rateTypes.taxRate, label: "Manage Tax Rate", description: "" },
    },
    [scopeIds.audit.id]: {
        auditTrail: { id: `audit_trail`, label: "Manage Audit Trails", description: "" },
        auditTrailTag: { id: `audit_trail_tag`, label: "Manage Audit Trail Tags", description: "" },
    },
    [scopeIds.wallet.id]: {
        wallet: { id: walletTypes.wallet, label: "Manage Wallets", description: "" },
        walletUser: { id: walletTypes.walletUser, label: "Manage Wallet Users", description: "" },
    },
    [scopeIds.transaction.id]: {
        request: { id: transactionTypes.request, label: "Manage Request Transactions", description: "" },
        wallet: { id: transactionTypes.wallet, label: "Manage Wallet Transactions", description: "" },
    },
    [scopeIds.userApiKey.id]: {
        apiKey: { id: userApiKeyTypes.apiKey, label: "Manage User API Keys", description: "" }
    }
}

export const functionActionTypes = {
    pageAccess: "pageAccess",
    callAction: "callAction"
}

export const functionTypes = {
    pageList: { id: "pageList", label: "Browse", type: functionActionTypes.pageAccess, description: "View Listing" },
    pageNew: { id: "pageNew", label: "Create", type: functionActionTypes.pageAccess, description: "Create New" },
    pageView: { id: "pageView", label: "View", type: functionActionTypes.pageAccess, description: "View Detail" },
    pageUpdate: { id: "pageUpdate", label: "Update", type: functionActionTypes.pageAccess, description: "Modify Detail" },
    pageStockPost: { id: "pageStockPost", label: "Post to Stock", type: functionActionTypes.pageAccess, description: "Update Stock" },
    pageVerifyOut: { id: "pageVerifyOut", label: "Verify Out", type: functionActionTypes.pageAccess, description: "Stock Deduction" },
    pageVerifyIn: { id: "pageVerifyIn", label: "Verify In", type: functionActionTypes.pageAccess, description: "Stock Increment" },
    pageVerifyTransferIn: { id: "pageVerifyTransferIn", label: "Verify Transfer In", type: functionActionTypes.pageAccess, description: "Transfer Increment" },
    pageExecute: { id: "pageExecute", label: "Execute", description: "Execution" },
    pagePack: { id: "pagePack", label: "Pack", type: functionActionTypes.pageAccess, description: "Perform Packing" },
    pageImages: { id: "pageImages", label: "Images", type: functionActionTypes.pageAccess, description: "Manage Images" },
    pageSettings: { id: "pageSettings", label: "Settings", type: functionActionTypes.pageAccess, description: "Manage Settings" },
    pageChildrenNew: { id: "pageChildrenNew", label: "Create Children", type: functionActionTypes.pageAccess, description: "Create Sub Assets" },
    pageChildrenUpdate: { id: "pageChildrenUpdate", label: "Update Children", type: functionActionTypes.pageAccess, description: "Modify Sub Assets" },

    remove: { id: "remove", label: "Remove", type: functionActionTypes.callAction, description: "Deletion" },
    removeChildren: { id: "removeChildren", label: "Remove Children", type: functionActionTypes.callAction, description: "Sub Assets Deletion" },
    cancel: { id: "cancel", label: "Cancel", type: functionActionTypes.callAction, description: "Cancellation" },
    verifyOutLogs: { id: "verifyOutLogs", label: "Verify Out History", type: functionActionTypes.callAction, description: "Browse History" },
    verifyOutUndo: { id: "verifyOutUndo", label: "Undo Verify Out", type: functionActionTypes.callAction, description: "Undo Action" },
    verifyOutNew: { id: "verifyOutNew", label: "Create Verify Out", type: functionActionTypes.callAction, description: "Perform Action" },
    verifyInLogs: { id: "verifyInLogs", label: "Verify In History", type: functionActionTypes.callAction, description: "Browse History" },
    verifyInUndo: { id: "verifyInUndo", label: "Undo Verify In", type: functionActionTypes.callAction, description: "Undo Action" },
    verifyInNew: { id: "verifyInNew", label: "Create Verify In", type: functionActionTypes.callAction, description: "Perform Action" },
    verifyTransferInLogs: { id: "verifyTransferInLogs", label: "Verify Transfer In History", type: functionActionTypes.callAction, description: "Browse History" },
    verifyTransferInUndo: { id: "verifyTransferInUndo", label: "Create Verify Transfer In", type: functionActionTypes.callAction, description: "Undo Action" },
    verifyTransferInNew: { id: "verifyTransferInNew", label: "Undo Verify Transfer In", type: functionActionTypes.callAction, description: "Perform Action" },
}

export const permissionConfigs = {
    [scopeIds.product.id]: {
        [itemTypes.product]: {
            pageList: { admin: true, workstation: true, retail: true },
            pageNew: { admin: true },
            pageView: { admin: true, workstation: true, retail: true },
            pageUpdate: { admin: true },
            remove: { admin: true },
        },
        [itemTypes.item]: {
            pageNew: { admin: true },
            pageUpdate: { admin: true },
            pageImages: { admin: true },
            pageSettings: { admin: true },
            remove: { admin: true },
        },
        [itemTypes.category]: {
            pageList: { admin: true },
            pageNew: { admin: true },
            pageUpdate: { admin: true },
            remove: { admin: true },
            pageChildrenNew: { admin: true },
            pageChildrenUpdate: { admin: true },
            removeChildren: { admin: true },
        },
        [itemTypes.brand]: {
            pageList: { admin: true },
            pageNew: { admin: true },
            pageUpdate: { admin: true },
            remove: { admin: true },
        },
        [itemTypes.uom]: {
            pageList: { admin: true },
            pageNew: { admin: true },
            pageUpdate: { admin: true },
            remove: { admin: true },
        },
    },
    [scopeIds.document.id]: {
        [documentTypes.salesOrder]: {
            pageList: { admin: true, retail: true, customer: true },
            pageNew: { admin: true, retail: true, customer: true },
            pageUpdate: { admin: true, retail: true },
            pageView: { admin: true, retail: true, customer: true },
            remove: { admin: true, retail: true },
        },
        [documentTypes.proformaSales]: {
            pageList: { admin: true, retail: true },
            pageNew: { admin: true, retail: true },
            pageUpdate: { admin: true, retail: true },
            pageView: { admin: true, retail: true },
            remove: { admin: true, retail: true },
        },
        [documentTypes.salesInvoice]: {
            pageList: { admin: true, customer: true },
            pageNew: { admin: true },
            pageUpdate: { admin: true },
            pageView: { admin: true, customer: true },
            remove: { admin: true },
        },
        [documentTypes.cashSales]: {
            pageList: { admin: true, workstation: true },
            pageNew: { admin: true },
            pageView: { admin: true, workstation: true },
            pageVerifyOut: { admin: true, workstation: true },
            remove: { admin: true },
            cancel: { admin: true },
            verifyOutLogs: { admin: true, workstation: true },
            verifyOutUndo: { admin: true, workstation: true },
            verifyOutNew: { admin: true, workstation: true },
        },
        [documentTypes.retailCashSales]: {
            pageList: { admin: true, retail: true },
            pageNew: { admin: true, retail: true },
            pageView: { admin: true, retail: true },
            pageStockPost: { admin: true, retail: true },
            remove: { admin: true },
            cancel: { admin: true, retail: true },
        },
        [documentTypes.deliveryOrder]: {
            pageList: { admin: true, workstation: true, customer: true },
            pageNew: { admin: true },
            pageUpdate: { admin: true },
            pageView: { admin: true, workstation: true, customer: true },
            pageVerifyOut: { admin: true, workstation: true },
            remove: { admin: true },
            verifyOutLogs: { admin: true, workstation: true },
            verifyOutUndo: { admin: true, workstation: true },
            verifyOutNew: { admin: true, workstation: true },
        },
        [documentTypes.replacementDelivery]: {
            pageList: { admin: true, workstation: true },
            pageNew: { admin: true },
            pageUpdate: { admin: true },
            pageView: { admin: true, workstation: true },
            pageVerifyOut: { admin: true, workstation: true },
            remove: { admin: true },
            verifyOutLogs: { admin: true, workstation: true },
            verifyOutUndo: { admin: true, workstation: true },
            verifyOutNew: { admin: true, workstation: true },
        },
        [documentTypes.salesDebitNote]: {
            pageList: { admin: true },
            pageNew: { admin: true },
            pageUpdate: { admin: true },
            pageView: { admin: true },
            pageVerifyOut: { admin: true },
            remove: { admin: true },
            verifyOutLogs: { admin: true },
            verifyOutUndo: { admin: true },
            verifyOutNew: { admin: true },
        },
        [documentTypes.salesCreditNote]: {
            pageList: { admin: true },
            pageNew: { admin: true },
            pageUpdate: { admin: true },
            pageView: { admin: true },
            pageVerifyIn: { admin: true },
            remove: { admin: true },
            verifyInLogs: { admin: true },
            verifyInUndo: { admin: true },
            verifyInNew: { admin: true },
        },
        [documentTypes.purchaseOrder]: {
            pageList: { admin: true, retail: true },
            pageNew: { admin: true, retail: true },
            pageUpdate: { admin: true, retail: true },
            pageView: { admin: true, retail: true },
            remove: { admin: true, retail: true },
        },
        [documentTypes.purchaseReturn]: {
            pageList: { admin: true, retail: true, workstation: true },
            pageNew: { admin: true, retail: true },
            pageUpdate: { admin: true, retail: true },
            pageView: { admin: true, retail: true, workstation: true },
            pageVerifyOut: { admin: true, retail: true, workstation: true },
            remove: { admin: true, retail: true },
            verifyOutLogs: { admin: true, retail: true, workstation: true },
            verifyOutUndo: { admin: true, retail: true, workstation: true },
            verifyOutNew: { admin: true, retail: true, workstation: true },
        },
        [documentTypes.purchaseInvoice]: {
            pageList: { admin: true, retail: true },
            pageNew: { admin: true, retail: true },
            pageUpdate: { admin: true, retail: true },
            pageView: { admin: true, retail: true },
            remove: { admin: true, retail: true },
        },
        [documentTypes.itemReceive]: {
            pageList: { admin: true, retail: true, workstation: true },
            pageNew: { admin: true, retail: true },
            pageUpdate: { admin: true, retail: true },
            pageView: { admin: true, retail: true, workstation: true },
            pageVerifyIn: { admin: true, retail: true, workstation: true },
            remove: { admin: true, retail: true },
            verifyInLogs: { admin: true, retail: true, workstation: true },
            verifyInUndo: { admin: true, retail: true, workstation: true },
            verifyInNew: { admin: true, retail: true, workstation: true },
        },
        [documentTypes.itemTransfer]: {
            pageList: { admin: true, retail: true, workstation: true },
            pageNew: { admin: true, retail: true },
            pageUpdate: { admin: true, retail: true },
            pageView: { admin: true, retail: true, workstation: true },
            pageVerifyTransferIn: { admin: true, retail: true, workstation: true },
            pageVerifyOut: { admin: true, retail: true, workstation: true },
            remove: { admin: true, retail: true },
            verifyTransferInLogs: { admin: true, retail: true, workstation: true },
            verifyTransferInUndo: { admin: true, retail: true, workstation: true },
            verifyTransferInNew: { admin: true, retail: true, workstation: true },
            verifyOutLogs: { admin: true, retail: true, workstation: true },
            verifyOutUndo: { admin: true, retail: true, workstation: true },
            verifyOutNew: { admin: true, retail: true, workstation: true },
        },
        [documentTypes.itemRelocate]: {
            pageList: { admin: true, retail: true, workstation: true },
            pageNew: { admin: true, retail: true, workstation: true },
            pageUpdate: { admin: true },
            pageView: { admin: true, retail: true, workstation: true },
            remove: { admin: true, retail: true, workstation: true }
        },
        [documentTypes.itemTransform]: {
            pageList: { admin: true, retail: true, workstation: true },
            pageNew: { admin: true, retail: true, workstation: true },
            pageView: { admin: true, retail: true, workstation: true },
            // remove: { admin: true, workstation: true }
        },
        [documentTypes.itemIssue]: {
            pageList: { admin: true },
            pageNew: { admin: true },
            pageUpdate: { admin: true },
            pageView: { admin: true },
            pageVerifyOut: { admin: true },
            remove: { admin: true },
            verifyOutLogs: { admin: true },
            verifyOutUndo: { admin: true },
            verifyOutNew: { admin: true },
        },
        [documentTypes.itemAdjustment]: {
            pageList: { admin: true },
            pageNew: { admin: true },
            pageUpdate: { admin: true },
            pageView: { admin: true },
            pageVerifyIn: { admin: true },
            pageVerifyOut: { admin: true },
            remove: { admin: true },
            verifyInLogs: { admin: true },
            verifyInUndo: { admin: true },
            verifyInNew: { admin: true },
            verifyOutLogs: { admin: true },
            verifyOutUndo: { admin: true },
            verifyOutNew: { admin: true },
        },
        [documentTypes.stockTake]: {
            pageList: { admin: true, retail: true, workstation: true },
            pageNew: { admin: true, retail: true, workstation: true },
            pageUpdate: { admin: true, retail: true, workstation: true },
            pageView: { admin: true, retail: true, workstation: true },
            pageExecute: { admin: true, retail: true, workstation: true },
            remove: { admin: true, retail: true, workstation: true }
        },
        [documentTypes.transferReturn]: {
            pageList: { admin: true, retail: true },
            pageNew: { admin: true, retail: true },
            pageUpdate: { admin: true, retail: true },
            pageView: { admin: true, retail: true },
            pageVerifyTransferIn: { admin: true, retail: true },
            pageVerifyOut: { admin: true, retail: true },
            remove: { admin: true, retail: true },
            verifyTransferInLogs: { admin: true, retail: true },
            verifyTransferInUndo: { admin: true, retail: true },
            verifyTransferInNew: { admin: true, retail: true },
            verifyOutLogs: { admin: true, retail: true },
            verifyOutUndo: { admin: true, retail: true },
            verifyOutNew: { admin: true, retail: true },
        },
        [documentTypes.transferRequisition]: {
            pageList: { admin: true, retail: true },
            pageNew: { admin: true, retail: true },
            pageUpdate: { admin: true, retail: true },
            pageView: { admin: true, retail: true },
            remove: { admin: true, retail: true },
        },
        [documentTypes.tripOrder]: {
            pageList: { admin: true, workstation: true },
            pageNew: { admin: true, workstation: true },
            pageUpdate: { admin: true, workstation: true },
            pageView: { admin: true, workstation: true },
            remove: { admin: true, workstation: true }
        },
        [documentTypes.pickOrder]: {
            pageList: { admin: true, workstation: true },
            pageNew: { admin: true, workstation: true },
            pageUpdate: { admin: true, workstation: true },
            pageView: { admin: true, workstation: true },
            remove: { admin: true, workstation: true }
        },
        [documentTypes.retailPrescription]: {
            pageList: { admin: true, retail: true },
            pageNew: { admin: true, retail: true },
            pageUpdate: { admin: true, retail: true },
            pageView: { admin: true, retail: true },
            remove: { admin: true, retail: true },
        },
    },
    [scopeIds.repository.id]: {
        [repositoryTypes.container]: {
            pageList: { admin: true },
            pageNew: { admin: true },
            pageUpdate: { admin: true },
            pageView: { admin: true },
            remove: { admin: true }
        },
        [repositoryTypes.package]: {
            pageList: { admin: true, workstation: true },
            pageNew: { admin: true, workstation: true },
            pageView: { admin: true, workstation: true },
            pagePack: { admin: true, workstation: true },
            remove: { admin: true, workstation: true }
        }
    },
    [scopeIds.logistic.id]: {
        [logisticTypes.transporter]: {
            pageList: { admin: true },
            pageNew: { admin: true },
            pageUpdate: { admin: true },
            remove: { admin: true },
        }
    },
    [scopeIds.operation.id]: {
        examine_inventory: {
            pageView: { admin: true, retail: true, workstation: true },
        },
        item_reorder_threshold: {
            pageView: { admin: true, workstation: true },
        },
        item_relocate_threshold: {
            pageView: { admin: true, workstation: true },
        },
    },
    [scopeIds.user.id]: {
        [userTypes.admin]: {
            pageList: { admin: true },
            pageNew: { admin: true },
            pageUpdate: { admin: true },
            // pageSettings: { admin: true },
            pageView: { admin: true },
            remove: { admin: true },
        },
        [userTypes.customer]: {
            pageList: { admin: true },
            pageNew: { admin: true },
            pageUpdate: { admin: true },
            // pageSettings: { admin: true },
            pageView: { admin: true },
            remove: { admin: true },
        },
        [userTypes.driver]: {
            pageList: { admin: true },
            pageNew: { admin: true },
            pageUpdate: { admin: true },
            // pageSettings: { admin: true },
            pageView: { admin: true },
            remove: { admin: true },
        },
        [userTypes.member]: {
            pageList: { admin: true, retail: true, },
            pageNew: { admin: true, retail: true },
            pageUpdate: { admin: true, retail: true },
            // pageSettings: { admin: true },
            pageView: { admin: true, retail: true },
            remove: { admin: true, retail: true },
        },
        [userTypes.retail]: {
            pageList: { admin: true },
            pageNew: { admin: true },
            pageUpdate: { admin: true },
            // pageSettings: { admin: true },
            pageView: { admin: true },
            remove: { admin: true },
        },
        [userTypes.supplier]: {
            pageList: { admin: true, retail: true },
            pageNew: { admin: true, retail: true },
            pageUpdate: { admin: true, retail: true },
            // pageSettings: { admin: true, retail: true },
            pageView: { admin: true, retail: true },
            remove: { admin: true, retail: true },
        },
        [userTypes.worker]: {
            pageList: { admin: true },
            pageNew: { admin: true },
            pageUpdate: { admin: true },
            // pageSettings: { admin: true },
            pageView: { admin: true },
            remove: { admin: true },
        },
    },
    [scopeIds.userRole.id]: {
        [`role`]: {
            pageList: { admin: true },
            pageNew: { admin: true },
            pageUpdate: { admin: true },
            remove: { admin: true },
        },
        [`permission`]: {
            pageUpdate: { admin: true }
        },
    },
    [scopeIds.userBranches.id]: {
        [branchTypes.customer]: {
            pageNew: { admin: true },
            pageUpdate: { admin: true },
            remove: { admin: true },
        },
        [branchTypes.retail]: {
            pageNew: { admin: true },
            pageUpdate: { admin: true },
            remove: { admin: true },
        },
    },
    [scopeIds.branchUsers.id]: {
        [branchUserTypes.customer]: {
            pageNew: { admin: true },
            pageUpdate: { admin: true },
            remove: { admin: true },
        },
        [branchUserTypes.retailer]: {
            pageNew: { admin: true },
            pageUpdate: { admin: true },
            remove: { admin: true },
        },
    },
    [scopeIds.group.id]: {
        [groupTypes.administrator]: {
            pageList: { admin: true },
            pageNew: { admin: true },
            pageUpdate: { admin: true },
            remove: { admin: true },
        },
        [groupTypes.customer]: {
            pageList: { admin: true },
            pageNew: { admin: true },
            pageUpdate: { admin: true },
            remove: { admin: true },
        },
        [groupTypes.supplier]: {
            pageList: { admin: true },
            pageNew: { admin: true },
            pageUpdate: { admin: true },
            remove: { admin: true },
        }
    },
    [scopeIds.region.id]: {
        [regionTypes.country]: {
            pageList: { admin: true },
            pageUpdate: { admin: true }
        },
        [regionTypes.area]: {
            pageNew: { admin: true },
            pageUpdate: { admin: true },
            remove: { admin: true },
        }
    },
    [scopeIds.business.id]: {
        [businessTypes.business]: {
            pageList: { admin: true },
            pageNew: { admin: true },
            pageUpdate: { admin: true },
            remove: { admin: true },
        }
    },
    [scopeIds.customField.id]: {
        [customFieldTypes.account]: {
            pageList: { admin: true },
            pageNew: { admin: true },
            pageUpdate: { admin: true },
            remove: { admin: true },
        }
    },
    [scopeIds.injectionProp.id]: {
        [`default`]: {
            pageList: { admin: true },
            pageNew: { admin: true },
            remove: { admin: true },
        }
    },
    [scopeIds.injectionField.id]: {
        [`default`]: {
            pageList: { admin: true },
            pageNew: { admin: true },
            remove: { admin: true },
        }
    },
    [scopeIds.report.id]: {
        [reportTypes.product.productItem.key]: {
            pageView: { admin: true, retail: true },
        },
        [reportTypes.sales.salesOrder.key]: {
            pageView: { admin: true, retail: true },
        },
        [reportTypes.sales.salesOrderItem.key]: {
            pageView: { admin: true, retail: true },
        },
        [reportTypes.sales.deliveryOrder.key]: {
            pageView: { admin: true, retail: true },
        },
        [reportTypes.sales.deliveryOrderItem.key]: {
            pageView: { admin: true, retail: true },
        },
        [reportTypes.warehouse.itemReceive.key]: {
            pageView: { admin: true, retail: true },
        },
        [reportTypes.warehouse.itemReceiveItem.key]: {
            pageView: { admin: true, retail: true },
        },
        [reportTypes.warehouse.itemTransfer.key]: {
            pageView: { admin: true, retail: true },
        },
        [reportTypes.warehouse.itemTransferItem.key]: {
            pageView: { admin: true, retail: true },
        },
        // [reportTypes.sales.retailCashSales.key]: {
        //     pageView: { admin: true, retail: true },
        // },
        // [reportTypes.other.retailPrescription.key]: {
        //     pageView: { admin: true, retail: true },
        // },
    },
    [scopeIds.scheduler.id]: {
        [schedulerTypes.schedulerTask]: {
            pageList: { admin: true },
            pageNew: { admin: true },
            pageUpdate: { admin: true },
            remove: { admin: true },
        },
        [schedulerTypes.schedulerLog]: {
            pageList: { admin: true, workstation: true },
            pageView: { admin: true, workstation: true },
            pageNew: { admin: true },
            // pageUpdate: { admin: true },
            // remove: { admin: true },
        },
        [schedulerTypes.schedulerRequest]: {
            pageList: { admin: true, workstation: true },
            pageView: { admin: true, workstation: true },
            // pageUpdate: { admin: true },
            // remove: { admin: true },
        },
        [`console`]: {
            pageList: { admin: true }
        },
    },
    [scopeIds.rate.id]: {
        [rateTypes.shippingRate]: {
            pageList: { admin: true },
            pageNew: { admin: true },
            pageUpdate: { admin: true },
            remove: { admin: true },
        },
        [rateTypes.shippingRule]: {
            pageList: { admin: true },
            pageNew: { admin: true },
            pageUpdate: { admin: true },
            remove: { admin: true },
        },
        [rateTypes.taxRate]: {
            pageList: { admin: true },
            pageNew: { admin: true },
            pageUpdate: { admin: true },
            remove: { admin: true },
        }
    },
    [scopeIds.audit.id]: {
        [`audit_trail`]: {
            pageList: { admin: true },
            pageView: { admin: true },
            pageNew: { admin: true },
            remove: { admin: true },
        },
        [`audit_trail_tag`]: {
            pageList: { admin: true },
            remove: { admin: true },
        },
    },
    [scopeIds.wallet.id]: {
        [walletTypes.wallet]: {
            pageList: { admin: true },
            pageView: { admin: true },
            pageUpdate: { admin: true },
            pageNew: { admin: true },
            remove: { admin: true },
        },
        [walletTypes.walletUser]: {
            pageList: { admin: true }
        },
    },
    [scopeIds.transaction.id]: {
        [transactionTypes.request]: {
            pageList: { admin: true },
            pageView: { admin: true },
            pageUpdate: { admin: true },
            pageNew: { admin: true },
            remove: { admin: true }
        },
        [transactionTypes.wallet]: {
            pageList: { admin: true },
            pageView: { admin: true },
            pageUpdate: { admin: true },
            pageNew: { admin: true },
            remove: { admin: true }
        },
    },
    [scopeIds.userApiKey.id]: {
        [userApiKeyTypes.apiKey]: {
            pageList: { admin: true },
            pageView: { admin: true },
            pageUpdate: { admin: true },
            pageNew: { admin: true },
            remove: { admin: true },
        }
    },
}

// console.log('permiss', permissionConfigs)
